<script>
  export let isOpen = false;
  export let openCloseMenu;
  const navigation = [
    // { textLink: "OFFERS", link: "/offers" },
    { textLink: "BEST SELLERS", link: "/best-sellers" },
    { textLink: "COLLECTIONS", link: "/collections" },
    { textLink: "FLASH GLITTER", link: "/collections/flash-glitter" },
    { textLink: "CAT EYE", link: "/collections/cat-eye" },
    { textLink: "COSMIC CAT EYE", link: "/collections/cosmic-cat-eye" },
    { textLink: "ASTRO FLASH", link: "/collections/astro-flash" },
    { textLink: "VELVET MAGNET", link: "/collections/velvet-magnet" },
    { textLink: "INSTA-CHROME PENS", link: "/collections/insta-chrome-pens" },
    // { textLink: "MAGICAL MOMENTS", link: "/collections/magical-moments" },
    // { textLink: "HARD ROCK X RCM", link: "/collections/hard-rock-x-rcm" },
    // { textLink: "THE LUXE LIFE", link: "/collections/the-luxe-life" },
    // { textLink: "FRENCH KISS", link: "/collections/french-kiss" },
    // { textLink: "KYOTO CALLING", link: "/collections/kyoto-calling" },
    // { textLink: "AMALFI GETAWAY", link: "/collections/amalfi-getaway" },
    // { textLink: "An Enchanting Affair", link: "/collections/an-enchanting-affair"},
    // { textLink: "STYLE BLOOMS", link: "/collections/style-blooms" },
    // { textLink: "HOLLYWOOD WALK OF FAME COLLECTION", link: "/collections/hollywood-walk-of-fame-collection"},
    // { textLink: "FORTIFY & PROTECT", link: "/gel-polish/fortify-protect" },
    { textLink: "CREAM GEL", link: "/gel-polish/cream-gel" },
    { textLink: "LED GEL POLISH", link: "/gel-polish/led-gel-polish" },
    { textLink: "COLOUR DIP", link: "/colour-dip" },
    { textLink: "ESSENTIALS", link: "/essentials" },
    { textLink: "LED LIGHTS", link: "/led-lights" },
    { textLink: "KITS", link: "/kits" },
    { textLink: "SOFT GEL", link: "/soft-gel" },
    { textLink: "HOW TO", link: "/how-to" },
    { textLink: "VIDEOS", link: "/video" },
  ];
</script>

<nav class="mobile-nav" class:active={isOpen}>
  <ul role="menu" class="mobile-main">
    {#if navigation}
      {#each navigation as nav}
        <li class="menu-mobile">
          <a href={nav.link} on:click={openCloseMenu}>{nav.textLink}</a>
        </li>
      {/each}
    {/if}
  </ul>
</nav>

<style>
  a {
    text-decoration: none;
    font-size: 2.2rem;
    color: #fff;
    line-height: 1;
    text-transform: uppercase;
  }
  li {
    list-style: none;
  }
  .mobile-nav {
    display: none;
  }
  .mobile-nav.active {
    position: fixed;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    width: 100svw;
    height: 100svh;
    top: 0;
    left: 0;
    z-index: 2;
    color: #fff;
    background-color: var(--global);
    overflow: hidden;
  }
  ul {
    display: flex;
    flex-direction: column;
    width: 90%;
    height: 90%;
    gap: 1.5rem;
    overflow-y: scroll;
    padding: 0 0 30px 0;
  }
  @media (min-width: 1024px) {
    a {
      font-size: 2.5rem;
    }
    ul {
      gap: 3rem;
    }
  }
  @media (hover: hover) and (min-width: 1024px) {
    .mobile-nav {
      display: none;
    }
  }
</style>
